import {
  faPlus,
  faList,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import {
  setCurrentUser,
  resetUserMaster,
  setDetailParams,
  setIsNewEntry,
  resetDetail,
} from "../../state/userMasterSlice.js"
import { apiRoute, linksUrl } from "../../constants/enum.js"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import {
  ConfirmBox,
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components/index.js"
import { ROW_ACTION_BTN_TYPE } from "../../components/NextUITable.jsx"
import { useEffect, useState } from "react"

function UserMaster() {
  const navigate = useNavigate()
  const [itemToDelete, setItemToDelete] = useState("")
  const dispatch = useDispatch()


  const exportColumns = [
    { uid: "UserId", name: "User Id" },
    { uid: "FirstName", name: "First Name" },
    { uid: "LastName", name: "Last Name" },
    { uid: "LoginName", name: "Login Name" },
    { uid: "Email_Id", name: "Email Id" },
    { uid: "Contact_No", name: "Contact No" },
  ]

  const onClickPrevPage = () => {

  }

  const {
    isPending,
    isError,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.userMaster.getEntryData,
    queryKey: "UserMaster"

  })

  useEffect(() => {
    filterData({
      data: {
        user_id: '',
      },
    })
  }, [])

  const { mutate: funDelete } = usePost({
    url: apiRoute.userMaster.deleteEntry,
    queryKey: "deleteEntryUser",
    onSuccessTasks: (data) => {
      setItemToDelete("")
      filterData({
        data: {
          user_id: '',
        },
      })
    }


  });

  const columns = [
    {
      name: "ACTIONS",
      uid: "actions",
    },
    { uid: "UserId", name: "User Id" },
    { uid: "FirstName", name: "First Name" },
    { uid: "LastName", name: "Last Name" },
    { uid: "LoginName", name: "Login Name" },
    { uid: "Email_Id", name: "Email Id" },
    { uid: "Contact_No", name: "Contact No" },
  ]

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "UserId",
    "FirstName",
    "LastName",
    "LoginName",
    "Email_Id",
    "Contact_No",
  ]

  const topActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPlus} />,
      onClick: () => {
        navigate(linksUrl.user.createEntry)
        dispatch(resetDetail())
      },
      label: "Add User",
    },
  ]

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPenToSquare} className="text-lime-600 text-md p-3 bg-lime-50" />,
      onClick: (row) => {
        dispatch(setDetailParams(row))
        dispatch(setIsNewEntry(false))
        navigate(linksUrl.user.createEntry)
      },
      label: "",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faTrash} className="text-red-600 text-md bg-red-50 p-3" />,
      onClick: (row) => {
        setItemToDelete(row)
      },
      // label: "Delete",

      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  const handleConfirmBox = (data) => {
    if (data) {
      if (itemToDelete && itemToDelete != null) {
        funDelete({
          data: {
            user_id: itemToDelete?.UserId || 0
          }
        })
      }
    }
    else {
      setItemToDelete("")
    }
  };

  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  /*  */
  return (
    <div>
      <MainContainer
        // pageName="User Master"
        breadcrumbs={["User Master"]}
      >
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          topActionBtn={topActionBtn}
          rowActionBtn={rowActionBtn}
          //  rowMenuActionBtn={rowMenuActionBtn}
          downloadFileName="User_Master"
          id="UserId"
        />
      </MainContainer>
      {(itemToDelete) && (
        <ConfirmBox
          handleConfirmBox={handleConfirmBox}
        />
      )}
    </div>
  )
}

export default UserMaster
